import * as Yup from 'yup';

export const CompleteMeetSchema = Yup.object({
  comment: Yup.string()
    .trim()
    .min(10, 'El comentario debe tener al menos 10 caracteres')
    .required('Este campo es requerido'),
});
